/** ISO 4217:2015 currencies with 0 decimal places (display only). */
export const ZERO_DECIMAL_CURRENCIES: ReadonlySet<string> = new Set(['JPY', 'CLP', 'VND', 'IDR', 'KHR', 'PYG']);
